<template>
  <o-view :has-white-background="true" :no-scroll="true">
    <o-nav-bar title="Je Cambio-wagen sluiten" :has-back-button="true" />
    <o-section>
      <p>
        Volg onderstaande instructies om je Cambio-wagen
        <strong>definitief</strong> te sluiten.
      </p>
      <ol>
        <li>
          <p><strong>Zet de wagen terug op zijn standplaats.</strong></p>
        </li>
        <li>
          <p><strong>Doe de Cambio check:</strong></p>
          <o-alert>
            <ul>
              <li>Brandstoftank is voor 1/4 gevuld</li>
              <li>De lichten zijn uit</li>
              <li>De ramen en deuren zijn gesloten</li>
              <li>Er zijn geen persoonlijke spullen meer in de wagen</li>
            </ul>
          </o-alert>
        </li>
        <li>
          <p>
            <strong
              >Volg de instructies op de boordcomputer in de wagen vooraleer je
              de wagen sluit.</strong
            >
          </p>
        </li>
        <li>
          <p><strong>Sluit de wagen met deze app.</strong></p>
          <o-alert>
            <p>
              Opgelet: dit mag je enkel doen wanneer je wagen terug op de
              standplaats staat. Wil je parkeren zonder je reservatie te
              stoppen? Gebruik gewoon je sleutel.
            </p>
          </o-alert>
        </li>
      </ol>
    </o-section>
  </o-view>
</template>

<script>
export default {
  name: 'CambioEdit'
}
</script>
